/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
import { StreamContainer_settings$ref } from "./StreamContainer_settings.graphql";
import { StreamContainer_story$ref } from "./StreamContainer_story.graphql";
import { StreamContainer_viewer$ref } from "./StreamContainer_viewer.graphql";
export type StreamQueryVariables = {
    readonly storyID?: string | null;
    readonly storyURL?: string | null;
};
export type StreamQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": StreamContainer_viewer$ref;
    } | null;
    readonly story: {
        readonly " $fragmentRefs": StreamContainer_story$ref;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": StreamContainer_settings$ref;
    };
};
export type StreamQuery = {
    readonly response: StreamQueryResponse;
    readonly variables: StreamQueryVariables;
};



/*
query StreamQuery(
  $storyID: ID
  $storyURL: String
) {
  viewer {
    ...StreamContainer_viewer
    id
  }
  story: stream(id: $storyID, url: $storyURL) {
    ...StreamContainer_story
    id
  }
  settings {
    ...StreamContainer_settings
    id
  }
}

fragment StreamContainer_viewer on User {
  ...UserBoxContainer_viewer
  ...CreateCommentReplyMutation_viewer
  ...CreateCommentMutation_viewer
  ...PostCommentFormContainer_viewer
  ...SuspendedInfoContainer_viewer
  ...StreamDeletionRequestCalloutContainer_viewer
  status {
    current
  }
}

fragment StreamContainer_story on Story {
  ...PostCommentFormContainer_story
  ...StoryClosedTimeoutContainer_story
  ...CreateCommentReplyMutation_story
  ...CreateCommentMutation_story
  id
  url
  settings {
    mode
  }
  commentCounts {
    totalPublished
    tags {
      FEATURED
      UNANSWERED
    }
  }
}

fragment StreamContainer_settings on Settings {
  reaction {
    sortLabel
  }
  ...PostCommentFormContainer_settings
  ...UserBoxContainer_settings
  ...CommunityGuidelinesContainer_settings
  ...SuspendedInfoContainer_settings
  ...AnnouncementContainer_settings
}

fragment PostCommentFormContainer_settings on Settings {
  charCount {
    enabled
    min
    max
  }
  disableCommenting {
    enabled
    message
  }
  closeCommenting {
    message
  }
}

fragment UserBoxContainer_settings on Settings {
  auth {
    integrations {
      local {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      oidc {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      google {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
      facebook {
        enabled
        allowRegistration
        targetFilter {
          stream
        }
      }
    }
  }
}

fragment CommunityGuidelinesContainer_settings on Settings {
  communityGuidelines {
    enabled
    content
  }
}

fragment SuspendedInfoContainer_settings on Settings {
  organization {
    name
  }
}

fragment AnnouncementContainer_settings on Settings {
  announcement {
    id
    content
  }
}

fragment PostCommentFormContainer_story on Story {
  id
  isClosed
  ...MessageBoxContainer_story
  settings {
    messageBox {
      enabled
    }
    mode
  }
}

fragment StoryClosedTimeoutContainer_story on Story {
  id
  closedAt
}

fragment CreateCommentReplyMutation_story on Story {
  settings {
    moderation
  }
}

fragment CreateCommentMutation_story on Story {
  settings {
    moderation
  }
}

fragment MessageBoxContainer_story on Story {
  settings {
    messageBox {
      content
      icon
    }
    mode
  }
}

fragment UserBoxContainer_viewer on User {
  username
}

fragment CreateCommentReplyMutation_viewer on User {
  role
  badges
  createdAt
  status {
    current
    ban {
      active
    }
  }
}

fragment CreateCommentMutation_viewer on User {
  role
  createdAt
  badges
  status {
    current
    ban {
      active
    }
  }
}

fragment PostCommentFormContainer_viewer on User {
  id
  scheduledDeletionDate
}

fragment SuspendedInfoContainer_viewer on User {
  status {
    suspension {
      until
    }
  }
}

fragment StreamDeletionRequestCalloutContainer_viewer on User {
  scheduledDeletionDate
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "storyID",
            "type": "ID",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "storyURL",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "id",
            "variableName": "storyID"
        } as any),
        ({
            "kind": "Variable",
            "name": "url",
            "variableName": "storyURL"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "content",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "enabled",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
    } as any), v6 = [
        (v4 /*: any*/),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "allowRegistration",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "targetFilter",
            "storageKey": null,
            "args": null,
            "concreteType": "AuthenticationTargetFilter",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "stream",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "StreamQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_viewer",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": "story",
                    "name": "stream",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_story",
                            "args": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "FragmentSpread",
                            "name": "StreamContainer_settings",
                            "args": null
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "StreamQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "User",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "username",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "role",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "badges",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "createdAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "status",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserStatus",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "current",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "ban",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BanStatus",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "active",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "suspension",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "SuspensionStatus",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "until",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        },
                        (v2 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "scheduledDeletionDate",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": "story",
                    "name": "stream",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "Story",
                    "plural": false,
                    "selections": [
                        (v2 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "isClosed",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "settings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "StorySettings",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "messageBox",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "StoryMessageBox",
                                    "plural": false,
                                    "selections": [
                                        (v3 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "icon",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v4 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "mode",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "moderation",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "closedAt",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "commentCounts",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommentCounts",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "totalPublished",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "tags",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "CommentTagCounts",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "FEATURED",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "UNANSWERED",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "settings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Settings",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "reaction",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ReactionConfiguration",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "sortLabel",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "charCount",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CharCount",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "min",
                                    "args": null,
                                    "storageKey": null
                                },
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "max",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "disableCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "DisableCommenting",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "closeCommenting",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CloseCommenting",
                            "plural": false,
                            "selections": [
                                (v5 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "auth",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Auth",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "integrations",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "AuthIntegrations",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "local",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "LocalAuthIntegration",
                                            "plural": false,
                                            "selections": (v6 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "oidc",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "OIDCAuthIntegration",
                                            "plural": false,
                                            "selections": (v6 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "google",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "GoogleAuthIntegration",
                                            "plural": false,
                                            "selections": (v6 /*: any*/)
                                        },
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "facebook",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "FacebookAuthIntegration",
                                            "plural": false,
                                            "selections": (v6 /*: any*/)
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "communityGuidelines",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "CommunityGuidelines",
                            "plural": false,
                            "selections": [
                                (v4 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "organization",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Organization",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "name",
                                    "args": null,
                                    "storageKey": null
                                }
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "announcement",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Announcement",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/)
                            ]
                        },
                        (v2 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "StreamQuery",
            "id": "7fa4686d82d5e539df8a8a0db0458868",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '8eb57d1490a4242e8619d440f16a6b5a';
export default node;
